module.exports = __webpack_public_path__ + "img/2_2_3.cf07a8c9.png";